import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";


export type Room = {
  id: number;
  roomCode: string;
  siteId: string;
  floorsId: number;
}

type ListRoomsVariables = {
  nextToken?: string;
  siteId: string;
  floorId: number;
}

const listRooms: Source<Room[], ListRoomsVariables> = {
  graphql: parse(`
    query listRoomBySiteIdAndRoomCode($nextToken: String, $siteId: String, $floorId: Int) {
      listRoomBySiteIdAndRoomCode(
        limit: 10000,
        filter: { isActive: { eq: true }, floorsId: { eq: $floorId } }
        nextToken: $nextToken
        siteId: $siteId
      ) {
        nextToken
        items {
          id
          floorsId
          roomCode
          siteId
        }
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.QUERY,
    table: DynamoDbTables.ROOMS,
    index: "RoomBySiteIdAndRoomCode",
    keyCondition: ({ siteId }) => ({
      expression: "#siteId = :siteId",
      names: { "#siteId": "siteId" },
      values: { ":siteId": siteId },
    }),
    filter: ({ floorId }) => ({
      expression: "#isActive = :isActive AND #floorsId = :floorsId",
      names: { "#isActive": "isActive", "#floorsId": "floorsId" },
      values: { ":isActive": true, ":floorsId": floorId },
    }),
  },
};

type GetRoomVariables = {
  id: number;
}

const getRoomSource: Source<Room, GetRoomVariables> = {
  graphql: parse(`
    query getIRRoomMaster($id: Int!) {
      getIRRoomMaster(
        id: $id,
        modelName: "IRRoomMaster"
      ) {
        id
        floorsId
        roomCode
        siteId
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.GET,
    table: DynamoDbTables.ROOMS,
    key: ({ id }) => ({ modelName: "IRRoomMaster", id }),
  },
};

export const getRooms = async (client: SchemaClient, siteId: string, floorId: number): Promise<Room[] | typeof EMPTY_VALUE> => {
  return await client.queryList(listRooms, {siteId, floorId });
};

export const getRoom = async (client: SchemaClient, id: number): Promise<Room | typeof EMPTY_VALUE> => {
  return (await client.query(getRoomSource, { id }));
};

export const getAndProcessRooms = async (
  client: SchemaClient,
  siteId: string,
  floorId: number
): Promise<Room[]> => {
  const rooms = await getRooms(client, siteId, floorId);
  return rooms?.map((room: Room) => ({
      id: room.id,
      roomCode: room.roomCode,
      siteId: room.siteId,
      floorsId: room.floorsId
  })) ?? [];
};
